__turbopack_context__.v({
  "addTransition": "NavMenuWrapper-module__QgfEPG__addTransition",
  "footerEnabled": "NavMenuWrapper-module__QgfEPG__footerEnabled",
  "menuHeader": "NavMenuWrapper-module__QgfEPG__menuHeader",
  "navItem": "NavMenuWrapper-module__QgfEPG__navItem",
  "navLink": "NavMenuWrapper-module__QgfEPG__navLink",
  "navList": "NavMenuWrapper-module__QgfEPG__navList",
  "navMenu": "NavMenuWrapper-module__QgfEPG__navMenu",
  "navMenuWrapper": "NavMenuWrapper-module__QgfEPG__navMenuWrapper",
});
